import api from '../../plugins/api';

// Инициирует отправку SMS-кода клиенту для получения цифрового удостоверения
// личности через сервис ПКБ FCB ID OTP. Все обращения к внешнему ПКБ выполняет
// backend, сюда передаётся только id уже существующего клиента Doscar.
const pkbFcbSendCode = (id) => {
  return api.post(`/api/crm/clients/${id}/fcbid/send-code`);
};

export default pkbFcbSendCode;
